export default "__VITE_ASSET__68432bb1__"